// extracted by mini-css-extract-plugin
export default {"skeleton":"Skeleton__skeleton--2Tb","shine":"Skeleton__shine--NQJ"};